(() => {
  const initHeroes = (root = document) => {
    root.querySelectorAll('[data-hero]').forEach(hero => {
      const video = hero.querySelector('video');
      const button = hero.querySelector('[data-video-toggle]');
      if (!video || !button) return;
      if (video.hasAttribute('data-bundled-video') && !video.src && window.dropyVideoSource) video.src = window.dropyVideoSource;
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      video.muted = true;
      const update = () => { button.textContent = video.paused || video.ended ? button.dataset.play : button.dataset.pause; };
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('ended', update);
      button.addEventListener('click', () => {
        if (video.paused || video.ended) {
          if (video.ended) video.currentTime = 0;
          video.play().catch(() => { video.controls = true; });
        } else video.pause();
      });
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (video.currentSrc || video.src || video.querySelector('source')) video.play().catch(update);
        else video.addEventListener('loadeddata', () => video.play().catch(update), { once: true });
      }
    });
  };
  initHeroes();
  document.addEventListener('dropy:video-ready', () => initHeroes());
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-bundled-video]').forEach(video => {
      if (!video.src && window.dropyVideoSource) video.src = window.dropyVideoSource;
    });
    initHeroes();
  });
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close-drawer]');
    if (close) {
      const drawer = close.closest('details');
      drawer.open = false;
      drawer.querySelector('summary').focus();
    }
    const thumb = event.target.closest('[data-product-image]');
    if (thumb) {
      const main = thumb.closest('.product-gallery').querySelector('.product-main-image');
      main.removeAttribute('srcset'); main.src = thumb.dataset.productImage;
    }
  });
  document.addEventListener('toggle', event => {
    if (!event.target.matches('.drawer')) return;
    if (event.target.open) document.querySelectorAll('.drawer[open]').forEach(other => { if (other !== event.target) other.open = false; });
    document.body.style.overflow = document.querySelector('.drawer[open]') ? 'hidden' : '';
  }, true);
  document.addEventListener('keydown', event => {
    const drawer = document.querySelector('.drawer[open]');
    if (!drawer) return;
    if (event.key === 'Escape') {
      drawer.open = false;
      drawer.querySelector('summary').focus();
    }
    if (event.key === 'Tab') {
      const focusable = [...drawer.querySelectorAll('summary,a[href],button,input,select,textarea')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0];
    const section = event.target.closest('.product-section');
    section.querySelector('[data-product-price]').textContent = option.dataset.price;
    const compare = section.querySelector('[data-compare-price]');
    compare.hidden = !option.dataset.compare;
    compare.textContent = option.dataset.compare || '';
    const button = section.querySelector('[data-add-button]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
    if (option.dataset.image) {
      const image = section.querySelector('.product-main-image');
      if (image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    }
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.product-form') || (event.submitter && event.submitter.name !== 'add')) return;
    event.preventDefault();
    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-product-error]');
    button.disabled = true;
    error.hidden = true;
    try {
      const data = new FormData(form);
      data.set('sections', 'header');
      data.set('sections_url', location.pathname);
      const response = await fetch(document.body.dataset.cartAdd + '.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || form.dataset.error);
      const markup = result.sections && result.sections.header;
      if (!markup) { location.href = document.body.dataset.cartUrl; return; }
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const header = parsed.querySelector('[data-header]');
      if (!header) { location.href = document.body.dataset.cartUrl; return; }
      document.querySelector('[data-header]').replaceWith(header);
      if (window.dropySyncPacks) await window.dropySyncPacks();
      const drawer = document.getElementById('CartDrawer');
      drawer.open = true;
      drawer.querySelector('[data-close-drawer].icon-button').focus();
    } catch (reason) {
      error.textContent = reason.message || form.dataset.error;
      error.hidden = false;
    } finally {
      const selected = form.querySelector('[data-variant-select]').selectedOptions[0];
      button.disabled = selected.dataset.available !== 'true';
    }
  });
})();



(() => {
  const antiProductId = '15760941252948';

  function updateAntiPackLabel(root = document) {
    root.querySelectorAll('[data-cart-line][data-product-id="' + antiProductId + '"]').forEach(line => {
      const qty = Number(line.dataset.lineQuantity || 1);
      const info = line.querySelector('.mini-item-info');
      if (!info) return;

      const labels = [...info.querySelectorAll('.mini-item-variant')];
      const discountLike = labels.find(el =>
        /DRPYF2026|código secreto|25%|pack de 2|pack de 3|^pack$/i.test((el.textContent || '').trim())
      );

      const text = qty === 2 ? 'Pack de 2 · 15% de ahorro' : qty === 3 ? 'Pack de 3 · 20% de ahorro' : 'Pack';

      if (discountLike) {
        if ((discountLike.textContent || '').trim() !== text) discountLike.textContent = text;
      } else {
        const el = document.createElement('small');
        el.className = 'mini-item-variant';
        el.textContent = text;
        const title = info.querySelector('.mini-item-title');
        if (title) title.insertAdjacentElement('afterend', el);
        else info.prepend(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => updateAntiPackLabel());
  document.addEventListener('dropy:cart-synced', () => updateAntiPackLabel());
  document.addEventListener('shopify:section:load', () => updateAntiPackLabel());

  // No observamos todo el DOM: hacerlo provocaba un bucle de mutaciones y podía bloquear la carga.
  // Los eventos anteriores son suficientes para actualizar la etiqueta al cargar y al refrescar el carrito.
})();


(() => {
  const antiId = '15760941252948';
  const sepId = '15707633484116';

  function cartDestination(line) {
    const productId = String(line?.dataset?.productId || '');
    if (productId === antiId) return '/products/dispositivo-inteligente-antirronquidos?view=descanso';
    if (productId === sepId) return '/products/cargador-inteligente-para-el-ahorro-de-bateria?view=separador#comprar-drop';
    return null;
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cart-line] a');
    if (!link) return;
    const line = link.closest('[data-cart-line]');
    const destination = cartDestination(line);
    if (!destination) return;
    event.preventDefault();
    location.href = destination;
  });
})();


(()=>{const fmt=v=>new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR'}).format(v/100);async function sync(){const bars=[...document.querySelectorAll('[data-df-cart-sticky]')];if(!bars.length)return;try{const r=await fetch('/cart.js?sticky='+Date.now(),{cache:'no-store'}),c=await r.json();bars.forEach(b=>{const n=b.querySelector('[data-df-cart-count]'),t=b.querySelector('[data-df-cart-total]'),a=b.querySelector('[data-df-cart-action]'),buy=b.querySelector('[data-df-checkout-action]');if(n)n.textContent=c.item_count+' '+(c.item_count===1?'producto':'productos');if(t)t.textContent=fmt(c.total_price);if(a)a.onclick=()=>location.href='/cart';if(buy){buy.disabled=!c.item_count;buy.onclick=()=>{if(c.item_count)location.href='/checkout'}}})}catch(e){}}window.dropySyncStickyCart=sync;if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);else sync();window.addEventListener('pageshow',sync);document.addEventListener('dropy:cart-synced',sync);document.addEventListener('cart:updated',sync);setInterval(sync,2000)})();